module.exports = __webpack_public_path__ + "img/table1-en.421bf2fb.svg";